import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

export default function CookieBanner() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (!localStorage.getItem("nexon_cookies_ack")) setShow(true);
  }, []);
  if (!show) return null;
  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:max-w-md z-40 bg-foreground text-background rounded-2xl p-5 shadow-2xl" data-testid="cookie-banner">
      <p className="text-sm">
        We use cookies to keep you signed in and understand what's working. See our{" "}
        <Link to="/legal/cookies" className="underline">cookie policy</Link>.
      </p>
      <div className="mt-3 flex gap-2">
        <button
          data-testid="cookie-accept"
          className="btn-pill-accent text-xs px-5 py-2"
          onClick={() => { localStorage.setItem("nexon_cookies_ack", "1"); setShow(false); }}
        >
          Accept
        </button>
        <button
          data-testid="cookie-dismiss"
          className="text-xs px-5 py-2 rounded-full border border-background/30"
          onClick={() => setShow(false)}
        >
          Dismiss
        </button>
      </div>
    </div>
  );
}
